export const NUMBER_SIX = 6;

export const VALID_EMAIL = 'email@email.com';
export const INVALID_EMAIL = 'INVALIDEMAIL';
export const VALID_PASSWORD = '123123123';
export const INVALID_PASSWORD = '123';

export const testIds = {
  emailInput: 'email-input',
  passwordInput: 'password-input',
  loginSubmitButton: 'login-submit-btn',
};

export const USER_KEY = 'user';
export const MEALS_KEY = 'mealsToken';
export const DRINKS_KEY = 'drinksToken';

export const URL_FILTER_API = 'https://www.themealdb.com/api/json/v1/1/filter.php?i=';
export const URL_SEARCH_API = 'https://www.themealdb.com/api/json/v1/1/search.php?f=';

export const DONE_RECIPES = 'doneRecipes';
export const IN_PROGRESS = 'inProgressRecipes';

export const ID_BUTTON_SEARCH = 'search-top-btn';
export const ID_INPUT_SEARCH = 'search-input';
export const ID_BUTTON_GET_SEARCH = 'exec-search-btn';
export const ID_RADIO_NAME = 'exec-search-btn';
export const FAV_RECIPES = 'favoriteRecipes';
